export default __webpack_public_path__ + "assets/images/0b8eeccc26d0af7c1b576b30807cac1a.png";